var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "enter-active-class": _vm.theme.fadeEnterActive,
      "enter-class": _vm.theme.fadeEnter,
      "enter-to-class": _vm.theme.fadeEnterTo,
      "leave-active-class": _vm.theme.fadeLeaveActive,
      "leave-class": _vm.theme.fadeLeave,
      "leave-to-class": _vm.theme.fadeLeaveTo
    }
  }, [(_vm.active) ? _c('div', {
    class: _vm.theme.wrapper
  }, [_c('div', {
    class: _vm.theme.snackbar
  }, [_c('div', {
    class: _vm.theme.messageContainer
  }, [_c('v-text', {
    class: _vm.theme.message,
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))], {
    message: _vm.message
  })], 2)], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.actionContainer
  }, [_vm._t("action", [_c('v-button', {
    attrs: {
      "flat": "",
      "danger": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                        закрыть\n                    ")])])], 2)])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28936f5d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Snackbar/Snackbar.vue
// module id = 596
// module chunks = 0